import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
// 引入cookie-js
import Cookie from 'js-cookie'
import {
  resolve
} from 'path';
const router = new Router({
  mode: "history",
  routes: [{
      path: "/",
      meta: {
        title: '思普科技',
      },
      component: resolve => require(['@/components/index'], resolve),
      children: [{
          path: "/",
          meta: {
            title: '思普报价'
          },
          component: resolve => require(['@/components/product'], resolve),
        },
        {
          path: "/cart",
          meta: {
            title: '我的购物车',
            memberAuth: true
          },
          component: resolve => require(['@/components/cart'], resolve),
        },
        {
          path: '/deal',
          meta: {
            title: '我的订单',
            memberAuth: true
          },
          component: resolve => require(['@/components/deal'], resolve)
        },
      ]
    },
    {
      path: "/login",
      meta: {
        title: '管理登录',
      },
      component: resolve => require(['@/components/login'], resolve)
    },
    {
      path: '/manage/',
      meta: {
        title: '管理中心',
        adminAuth: true,
      },
      component: resolve => require(['@/components/manage/index'], resolve),
      children: [{
          path: "/manage/",
          meta: {
            title: '首页',
            adminAuth: true,
          },
          component: resolve => require(['@/components/manage/home'], resolve)
        },
        {
          path: "/manage/deal/lists",
          meta: {
            title: '订单列表',
            adminAuth: true,
          },
          component: resolve => require(['@/components/manage/deal/lists'], resolve)
        },
        {
          path: "/manage/product/lists",
          meta: {
            title: '产品列表',
            adminAuth: true,
          },
          component: resolve => require(['@/components/manage/product/lists'], resolve)
        },
        {
          path: "/manage/product/cate",
          meta: {
            title: '产品分类',
            adminAuth: true,
          },
          component: resolve => require(['@/components/manage/product/cate'], resolve)
        },
        {
          path: "/manage/member/lists",
          meta: {
            title: '会员管理',
            adminAuth: true,
          },
          component: resolve => require(['@/components/manage/member/lists'], resolve)
        },
        {
          path: "/manage/admin/lists",
          meta: {
            title: '人员管理',
            adminAuth: true,
          },
          component: resolve => require(['@/components/manage/admin/lists'], resolve)
        },
        {
          path: "/manage/admin/group",
          meta: {
            title: '角色管理',
            adminAuth: true,
          },
          component: resolve => require(['@/components/manage/admin/group'], resolve)
        },
        {
          path: "/manage/admin/menu",
          meta: {
            title: '权限管理',
            adminAuth: true,
          },
          component: resolve => require(['@/components/manage/admin/menu'], resolve)
        },
        {
          path: "/manage/setting/index",
          meta: {
            title: '权限管理',
            adminAuth: true,
          },
          component: resolve => require(['@/components/manage/setting/index'], resolve)
        }
      ]
    },
  ],

});

// 导航守卫
router.beforeEach((to, from, next) => {
  // 判断该路由是否需要登录权限
  if (to.meta.memberAuth) {
    let member = Cookie.get('member')
    if (member === undefined || member === 'e30=') {
      next({
        path: '/'
      })
    } else {
      next()
    }
  } else if (to.meta.adminAuth) {
    let admin = Cookie.get('admin')
    if (admin === undefined || admin === 'e30=') {
      console.log('no admin')
      next({
        path: '/login'
      })
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js